module.exports = "/images/veil-18.jpg";